/* tslint:disable */
/* eslint-disable */
/**
 * Create Employee
 * API for creating employees with their data
 *
 * The version of the OpenAPI document: _
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    CreateEmployeeRequest,
    CreateEmployeeRequestFromJSON,
    CreateEmployeeRequestToJSON,
    CreateEmployeeResponse,
    CreateEmployeeResponseFromJSON,
    CreateEmployeeResponseToJSON,
} from '../models';

export interface CreateEmployeePostRequest {
    createEmployeeRequest: CreateEmployeeRequest;
}

/**
 * 
 */
export class CreateEmployeeApi extends runtime.BaseAPI {

    /**
     * Creates an employee with the data provided.
     * Creates a employee
     */
    async createEmployeePostRaw(requestParameters: CreateEmployeePostRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<CreateEmployeeResponse>> {
        if (requestParameters.createEmployeeRequest === null || requestParameters.createEmployeeRequest === undefined) {
            throw new runtime.RequiredError('createEmployeeRequest','Required parameter requestParameters.createEmployeeRequest was null or undefined when calling createEmployeePost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/create-employee`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateEmployeeRequestToJSON(requestParameters.createEmployeeRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateEmployeeResponseFromJSON(jsonValue));
    }

    /**
     * Creates an employee with the data provided.
     * Creates a employee
     */
    async createEmployeePost(requestParameters: CreateEmployeePostRequest, initOverrides?: RequestInit): Promise<CreateEmployeeResponse> {
        const response = await this.createEmployeePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
